<mat-progress-bar class="progress-bar"
  [ngClass]="{'default': progressStyle === 'default', 'success': progressStyle === 'success', 'warning': progressStyle === 'warning', 'error': progressStyle === 'error'}"
  [mode]="mode"
  [value]="value"
  [attr.aria-label]="progressAriaLabel">
</mat-progress-bar>